import { TABLET_RESOLUTION } from '@/constants';
import { useWindowWidth } from './useWindowWidth';

export const useTabletWidth = () => {
  const width = useWindowWidth();
  const isTablet = width && width < TABLET_RESOLUTION;

  return isTablet;
};
